const updateStickySections = () => {
  const sections = document.querySelectorAll<HTMLElement>('.shopify-section');
  const viewportHeight = window.innerHeight;

  sections.forEach((section) => {
    // Third-party app blocks sit in Shopify's native `_blocks` section, whose markup we do not author,
    // so they cannot carry data-not-stacked. Stacking a section taller than the viewport pins it at a
    // negative top and puts its heading permanently out of reach, so opt them out: the overlap effect
    // is a device for our own sections.
    const hasNotStacked =
      section.querySelector('[data-not-stacked="true"]') ?? section.querySelector('.shopify-app-block');

    section.classList.toggle('not-stacked', !!hasNotStacked);

    if (hasNotStacked) return;

    const sectionHeight = section.offsetHeight;

    const top =
      sectionHeight > viewportHeight
        ? viewportHeight - sectionHeight
        : 0;

    section.style.setProperty('--sticky-section-top', `${top}px`);

    const stickyChildren = section.querySelectorAll<HTMLElement>('*');

    stickyChildren.forEach((el) => {
      const styles = getComputedStyle(el);

      if (styles.position !== 'sticky') return;
      if (el.closest('.js-ls-shop-the-look')) return;
      if (el.closest('.js-ls-full-bleed-media')) return;
      if (el.closest('.ls-plp-promo-slot')) return;
      // The sticky filter bar must pin to the real viewport top (top: 0), not be offset by the
      // stacked section's sticky-top — leave its `top` untouched.
      if (el.closest('.facets-block-wrapper--horizontal')) return;

      const originalTop = parseFloat(el.dataset.originalStickyTop ?? styles.top ?? '0') || 0;

      if (!el.dataset.originalStickyTop) {
        el.dataset.originalStickyTop = String(originalTop);
      }

      el.style.top = `${originalTop + Math.abs(top)}px`;
    });
  });
};

let resizeTimeout: number;

const scheduleUpdateStickySections = () => {
  requestAnimationFrame(() => {
    updateStickySections();
  });
};

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);

  resizeTimeout = window.setTimeout(() => {
    scheduleUpdateStickySections();
  }, 100);
});

window.addEventListener('load', scheduleUpdateStickySections);

document.fonts?.ready.then(scheduleUpdateStickySections);

const resizeObserver = new ResizeObserver(() => {
  scheduleUpdateStickySections();
});

document.querySelectorAll<HTMLElement>('.shopify-section').forEach((section) => {
  resizeObserver.observe(section);
});

scheduleUpdateStickySections();